import { accountService } from '@app/services';
import { SetIsResendingCode } from '@app/models';

export const checkIsUserRegisteredPhone = (
    contextToken: string,
    handleError: Function,
    setIsResendingCode: SetIsResendingCode
) => {
    accountService
        .getDataForResetMfa(contextToken, handleError)
        .then(() => {
            setIsResendingCode(false);
        });
};
